import { Directory, Filesystem } from '@capacitor/filesystem'
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener'
import write_blob from 'capacitor-blob-writer'
import { isMobileApp } from '~/shared/config/env'

export const openBlobFile = async (blob: Blob, path: string) => {
  if (isMobileApp) {
    const directoryPath = `/${path}`

    await write_blob({
      path: directoryPath,
      blob,
      directory: Directory.Cache,
    })

    const { uri } = await Filesystem.getUri({
      path: directoryPath,
      directory: Directory.Cache,
    })
    const fileOpenerOptions: FileOpenerOptions = {
      filePath: uri,
      contentType: blob.type,
    }

    await FileOpener.open(fileOpenerOptions)
  } else {
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }
}
